import { jsx as _jsx } from "react/jsx-runtime";
import { StatusTimelineDotExam } from "./components/StatusTimelineDotExam";
import { StatusTimelineDotProcess } from "./components/StatusTimelineDotProcess";
export function TimelineDot(_a) {
    var step = _a.step, data = _a.data;
    var isProcessStep = step.type === "process";
    return isProcessStep ? (_jsx(StatusTimelineDotProcess, { data: data, step: step })) : (_jsx(StatusTimelineDotExam, { data: data, step: step }));
}
